import { createTheme } from '@mui/material/styles';

export const revmacColors = {
  primary: {
    main: '#162B51',
    light: '#5981C8',
    dark: '#152B52',
  },
  secondary: {
    main: '#2395F1',
    light: '#D8EDFF',
    dark: '#2F60B8',
  },
  success: {
    main: '#10B981',
    light: '#34D39E',
    dark: '#047852',
  },
  warning: {
    main: '#F7B733',
    light: '#FFCD68',
    dark: '#B67D08',
  },
  error: {
    main: '#E10000',
    light: '#FC665A',
    dark: '#940000',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
};

export const revmacTheme = createTheme({
  palette: {
    mode: 'light',
    primary: revmacColors.primary,
    secondary: revmacColors.secondary,
    success: revmacColors.success,
    warning: revmacColors.warning,
    error: revmacColors.error,
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#162B51',
      secondary: '#616161',
    },
  },
  typography: {
    fontFamily: '"Lato", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 900, fontSize: '2.5rem', color: '#162B51' },
    h2: { fontWeight: 700, fontSize: '2rem', color: '#162B51' },
    h3: { fontWeight: 700, fontSize: '1.75rem', color: '#162B51' },
    h4: { fontWeight: 700, fontSize: '1.5rem', color: '#162B51' },
    h5: { fontWeight: 700, fontSize: '1.25rem', color: '#162B51' },
    h6: { fontWeight: 700, fontSize: '1rem', color: '#162B51' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          },
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #152B52 0%, #2F60B8 50%, #5981C8 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #162B51 0%, #2395F1 100%)',
          },
          // Override the gradient when disabled - MUI's default disabled rule
          // only touches backgroundColor, which the gradient shorthand wins
          // over, leaving low-contrast dark text on a saturated blue.
          '&.Mui-disabled': {
            background: 'none',
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: 'rgba(0, 0, 0, 0.38)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #152B52 0%, #2F60B8 50%, #5981C8 100%)',
          boxShadow: '0 2px 8px rgba(22, 43, 81, 0.15)',
          color: '#ffffff',
          '& .MuiTypography-root': { color: '#ffffff' },
          '& .MuiIconButton-root': { color: '#ffffff' },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: '#ffffff',
          borderRight: '1px solid #e0e0e0',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '4px 8px',
          '&.Mui-selected': {
            backgroundColor: '#D8EDFF',
            color: '#162B51',
            '&:hover': { backgroundColor: '#D8EDFF' },
            '& .MuiListItemIcon-root': { color: '#2395F1' },
          },
          '&:hover': { backgroundColor: '#f5f5f5' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.12)' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12 },
        elevation1: { boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
      },
    },
  },
});
